import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DesaparecidoCompDto } from 'src/app/shared/models/caso/desaparecido-cmp-dto.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DesaparecidoService {
  constructor(private http: HttpClient, private datepipe: DatePipe) { }

  findAll(): Observable<any> {
    return this.http.get(`${environment.apiSecurityUrl}api/v1/desaparecidos`);
  }

  findAllReport(desde: Date, hasta: Date, documento: string, complemento: string, nombres: string, paterno: string, materno: string, encontrado: boolean): Observable<any> {
    let params = ``;
    if (desde) {
      var dateDesde = this.datepipe.transform(desde, 'yyyy-MM-dd');
      params += `desde=${dateDesde}`;
    }
    if (hasta) {
      var dateHasta = this.datepipe.transform(hasta, 'yyyy-MM-dd');
      params += params !== "" ? `&hasta=${dateHasta}` : `hasta=${dateHasta}`;
    }
    if (documento) {
      params += params !== "" ? `&documento=${documento}` : `documento=${documento}`;
    }
    if (complemento) {
      params += params !== "" ? `&complemento=${complemento}` : `complemento=${complemento}`;
    }
    if (nombres) {
      params += params !== "" ? `&nombres=${nombres}` : `nombres=${nombres}`;
    }
    if (paterno) {
      params += params !== "" ? `&paterno=${paterno}` : `paterno=${paterno}`;
    }
    if (materno) {
      params += params !== "" ? `&materno=${materno}` : `materno=${materno}`;
    }
    if (encontrado) {
      params += params !== "" ? `&encontrado=${encontrado}` : `encontrado=${encontrado}`;
    }
    if (params !== "")
      params = "?" + params;
    return this.http.get(`${environment.apiSecurityUrl}api/v1/desaparecidos/report${params}`);
  }

  getDashboard(): Observable<any> {
    return this.http.get(`${environment.apiSecurityUrl}api/v1/desaparecidos/dashboard`);
  }

  syncJuliana(): Observable<any> {
    return this.http.get(`${environment.apiSecurityUrl}api/v1/desaparecidos/sync/juliana/all`);
  }

  findById(id: number): Observable<any> {
    return this.http.get(`${environment.apiSecurityUrl}api/v1/desaparecidos/${id}`);
  }

  getPdfReportUrl(desde: Date, hasta: Date, documento: string, complemento: string, nombres: string, paterno: string, materno: string, encontrado: boolean): string {
    let params = ``;
    if (desde) {
      var dateDesde = this.datepipe.transform(desde, 'yyyy-MM-dd');
      params += `desde=${dateDesde}`;
    }
    if (hasta) {
      var dateHasta = this.datepipe.transform(hasta, 'yyyy-MM-dd');
      params += params !== "" ? `&hasta=${dateHasta}` : `hasta=${dateHasta}`;
    }
    if (documento) {
      params += params !== "" ? `&documento=${documento}` : `documento=${documento}`;
    }
    if (complemento) {
      params += params !== "" ? `&complemento=${complemento}` : `complemento=${complemento}`;
    }
    if (nombres) {
      params += params !== "" ? `&nombres=${nombres}` : `nombres=${nombres}`;
    }
    if (paterno) {
      params += params !== "" ? `&paterno=${paterno}` : `paterno=${paterno}`;
    }
    if (materno) {
      params += params !== "" ? `&materno=${materno}` : `materno=${materno}`;
    }
    if (encontrado) {
      params += params !== "" ? `&encontrado=${encontrado}` : `encontrado=${encontrado}`;
    }
    if (params !== "")
      params = "?" + params;
    return `${environment.apiSecurityUrl}api/v1/desaparecidos/pdf${params}`;
  }

  downloadFile(url: string): Observable<Blob> {
    return this.http.get(`${url}`, { responseType: 'blob', headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' } })
  }

  update(id: number, dto: DesaparecidoCompDto): Observable<any> {
    return this.http.put(`${environment.apiSecurityUrl}api/v1/desaparecidos/${id}/cmp`, dto);
  }

  findCmpById(id: number): Observable<any> {
    return this.http.get(`${environment.apiSecurityUrl}api/v1/desaparecidos/${id}/cmp`);
  }

}
